import React from "react";
import { Link } from "react-router-dom";
import { motion } from "framer-motion";

export default function Header({ variant = "default" }) {
  return (
    <header className="sticky top-0 z-40 backdrop-blur-xl bg-black/60 border-b border-white/10">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 h-16 flex items-center justify-between">
        <Link to="/" className="flex items-center gap-2 group" data-testid="header-logo-link">
          <motion.div
            initial={{ rotate: 0 }}
            whileHover={{ rotate: 90 }}
            transition={{ duration: 0.4 }}
            className="w-7 h-7 rounded-md bg-[#C6F84C] flex items-center justify-center"
          >
            <span className="text-black font-black text-sm">QR</span>
          </motion.div>
          <span className="font-display font-bold tracking-tight">
            Readiness<span className="text-[#C6F84C]">.audit</span>
          </span>
        </Link>
        <nav className="flex items-center gap-6 text-sm text-zinc-400">
          <Link
            to="/methodology"
            className="hover:text-white transition-colors duration-200"
            data-testid="header-methodology-link"
          >
            Methodology
          </Link>
          {variant !== "quiz" && (
            <Link
              to="/quiz"
              className="hidden sm:inline-flex items-center rounded-full bg-[#C6F84C] hover:bg-[#B8FF3D] text-black font-bold px-4 py-2 transition-colors duration-200"
              data-testid="header-start-audit-btn"
            >
              Start audit
            </Link>
          )}
        </nav>
      </div>
    </header>
  );
}
